import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CommonApi from "../../../api/common.api";
import AddBtn from "../../../component/atoms/button/addBtn";
import DelBtn from "../../../component/atoms/button/delBtn";
import EditBtn from "../../../component/atoms/button/editBtn";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import ImgInput from "../../../component/atoms/input/imgInput";
import MainInput from "../../../component/atoms/input/mainInput";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import TableTab02 from "../../../component/molecules/tableTab02";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { imgUrl } from "../../../constants/url";
import { route } from "../../../router/route";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import Checkbox from "../../../component/atoms/input/checkbox";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import styled from "styled-components";
import BannerApi from "../../../api/banner.api";

const FinanceBanner = () => {
  const tab = [
    {
      title: "메인 페이지",
      link: route.service_banner_main,
      originLink: route.service_banner_main,
    },
    {
      title: "금융 스터디",
      link: route.service_banner_finance,
      originLink: route.service_banner_finance,
    },
  ];

  const [list, setList] = useState([]);
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const getList = async () => {
    try {
      const data = {
        bannerType: "STUDY",
      };

      let responseData = (await BannerApi.get(data)).data.data.content;
      setList(responseData.reverse());
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  //이미지 삭제
  const delImg = (index, type) => {
    const copyArr = [...list];
    const obj = copyArr[index];
    if (obj.file && type === "PC") {
      obj.file = "";
      obj.fileUrl = "";
    }
    if (obj.fileMo && type === "MO") {
      obj.fileMo = "";
      obj.fileUrlMo = "";
    }
    if (type === "PC") {
      obj.imageOriginFileNamePc = "";
      obj.imageServerFileNamePc = "";
    }
    if (type === "MO") {
      obj.imageOriginFileNameMo = "";
      obj.imageServerFileNameMo = "";
    }

    copyArr[index] = obj;
    setList(copyArr);
  };

  //이미지 추가
  const inputFile = (e, index, type) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (value) => {
      const copyArr = [...list];
      const obj = copyArr[index];

      if (type === "PC") {
        obj.file = file;
        obj.fileUrl = value.target.result;
      } else {
        obj.fileMo = file;
        obj.fileUrlMo = value.target.result;
      }

      setList(copyArr);
    };
    e.target.value = "";
  };

  //링크 변경
  const editLink = (e, index) => {
    const copyArr = [...list];
    const obj = copyArr[index];

    obj.link = e.target.value;

    setList(copyArr);
    e.target.value = "";
  };

  //새탭으로 이동
  const editNewOpen = (index, value) => {
    const copyArr = [...list];
    const obj = copyArr[index];

    obj.newOpen = value;

    setList(copyArr);
  };

  //새로운 배너 추가
  const addBannerList = () => {
    setList([
      ...list,
      {
        bannerType: "STUDY",
        link: "",
        newOpen: false,
        imageOriginFileNamePc: "",
        imageServerFileNamePc: "",
        imageOriginFileNameMo: "",
        imageServerFileNameMo: "",
      },
    ]);
  };

  // 저장
  const [saveIndex, setSaveIndex] = useState(-1);
  const saveFunc = async () => {
    try {
      const selectedBanner = list[saveIndex];
      const [pcResult, moResult] = await Promise.all([
        fileUpload(selectedBanner.file),
        fileUpload(selectedBanner.fileMo),
      ]);

      const data = {
        bannerType: "STUDY",
        imageOriginFileNamePc: pcResult.imageOriginFileName,
        imageServerFileNamePc: pcResult.imageServerFileName,
        imageOriginFileNameMo: moResult.imageOriginFileName,
        imageServerFileNameMo: moResult.imageServerFileName,
        link: selectedBanner.link.trim(),
        newOpen: selectedBanner.newOpen,
      };

      await BannerApi.add(data);
      setSaveModalOpen(false);

      toast(toastMsg.create);
      getList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 파일 업로드
  const fileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("path", "banner");
      formData.append("file", file);

      const response = (await CommonApi.fileUpload(formData)).data.data;

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch (error) {
      errorHandler(error);
    }
  };

  // 삭제
  const [delId, setDelId] = useState(-1);
  const [delModalOpen, setDelModalOpen] = useState(false);
  const delBanner = async () => {
    try {
      const data = {
        ids: [delId],
      };

      await BannerApi.delete(data);
      toast(toastMsg.delete);
      setDelModalOpen(false);
      setDelId(-1);
      getList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 수정
  const [editId, setEditId] = useState(-1);
  const [editIndex, setEditIndex] = useState(-1);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const editBanner = async () => {
    try {
      const data = {
        imageOriginFileNamePc: list[editIndex].imageOriginFileNamePc,
        imageServerFileNamePc: list[editIndex].imageServerFileNamePc,
        imageOriginFileNameMo: list[editIndex].imageOriginFileNameMo,
        imageServerFileNameMo: list[editIndex].imageServerFileNameMo,
        link: list[editIndex].link.trim(),
        newOpen: list[editIndex].newOpen,
      };

      if (!isNull(list[editIndex].file)) {
        const result = await fileUpload(list[editIndex].file);
        data.imageOriginFileNamePc = result.imageOriginFileName;
        data.imageServerFileNamePc = result.imageServerFileName;
      }
      if (!isNull(list[editIndex].fileMo)) {
        const result = await fileUpload(list[editIndex].fileMo);
        data.imageOriginFileNameMo = result.imageOriginFileName;
        data.imageServerFileNameMo = result.imageServerFileName;
      }

      await BannerApi.update(editId, data);

      setEditModalOpen(false);
      setEditId(-1);
      setEditIndex(-1);
      getList();

      toast(toastMsg.update);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <TableTitle>배너 관리</TableTitle>
          </DetailTop>

          <TableTab02 list={tab} />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 40,
            }}
          >
            {list.map((data, index) => (
              <DetailPage key={index}>
                <DetailPageTitle>슬라이드 배너{index + 1}</DetailPageTitle>
                <DetailPageForm style={{ alignItems: "flex-start" }}>
                  <DetailFormTitle>
                    PC 이미지*
                    <br />
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "24.5px",
                        color: "#ADB4BA",
                      }}
                    >
                      (권장사이즈 1920*500)
                    </span>
                  </DetailFormTitle>
                  {data.imageServerFileNamePc || data.fileUrl ? (
                    <div style={{ position: "relative" }}>
                      <img
                        style={{
                          width: "90px",
                          height: "90px",
                          borderRadius: "3px",
                        }}
                        src={data.fileUrl ? data.fileUrl : imgUrl + data.imageServerFileNamePc}
                        alt=""
                      />
                      <img
                        src="/assets/admin/icons/x.png"
                        alt=""
                        style={{
                          position: "absolute",
                          top: 6,
                          right: 6,
                          cursor: "pointer",
                        }}
                        onClick={() => delImg(index, "PC")}
                      />
                    </div>
                  ) : (
                    <ImgInput
                      id={`file${index}`}
                      accept={"image/*"}
                      onChange={(e) => {
                        inputFile(e, index, "PC");
                      }}
                    />
                  )}
                </DetailPageForm>
                <DetailPageForm style={{ alignItems: "flex-start", marginTop: "20px" }}>
                  <DetailFormTitle>
                    모바일 이미지*
                    <br />
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "24.5px",
                        color: "#ADB4BA",
                      }}
                    >
                      (권장사이즈 375*400)
                    </span>
                  </DetailFormTitle>
                  {data.imageServerFileNameMo || data.fileUrlMo ? (
                    <div style={{ position: "relative" }}>
                      <img
                        style={{
                          width: "90px",
                          height: "90px",
                          borderRadius: "3px",
                        }}
                        src={data.fileUrlMo ? data.fileUrlMo : imgUrl + data.imageServerFileNameMo}
                        alt=""
                      />
                      <img
                        src="/assets/admin/icons/x.png"
                        alt=""
                        style={{
                          position: "absolute",
                          top: 6,
                          right: 6,
                          cursor: "pointer",
                        }}
                        onClick={() => delImg(index, "MO")}
                      />
                    </div>
                  ) : (
                    <ImgInput
                      id={`fileMo${index}`}
                      accept={"image/*"}
                      onChange={(e) => {
                        inputFile(e, index, "MO");
                      }}
                    />
                  )}
                </DetailPageForm>
                <DetailPageForm style={{ marginTop: "20px" }}>
                  <DetailFormTitle>연결링크*</DetailFormTitle>
                  <MainInput
                    style={{
                      width: "338px",
                    }}
                    type={"text"}
                    placeholder={"https://"}
                    value={data?.link}
                    onChange={(e) => {
                      editLink(e, index);
                    }}
                  />
                </DetailPageForm>
                <DetailPageForm style={{ marginTop: "20px" }}>
                  <DetailFormTitle>이동</DetailFormTitle>
                  <CheckboxWrapper>
                    <Checkbox
                      id="newTab"
                      checked={data.newOpen}
                      onChange={() => {
                        editNewOpen(index, !data.newOpen);
                      }}
                    />
                    <DetailFormText>새창으로 이동</DetailFormText>
                  </CheckboxWrapper>
                </DetailPageForm>

                {data.id ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 6,
                      marginTop: "30px",
                    }}
                  >
                    <DelBtn
                      onClick={() => {
                        setDelId(data.id);
                        setDelModalOpen(true);
                      }}
                    />
                    <EditBtn
                      onClick={() => {
                        if (!data.link?.trim()) {
                          return toast("수정을 위해 연결링크를 입력해주세요.");
                        }
                        if (!data.file && !data.imageOriginFileNamePc) {
                          return toast("PC 이미지를 등록해주세요");
                        }
                        if (!data.fileMo && !data.imageOriginFileNameMo) {
                          return toast("모바일 이미지를 등록해주세요");
                        }

                        setEditId(data.id);
                        setEditIndex(index);
                        setEditModalOpen(true);
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "30px",
                    }}
                  >
                    <SaveBtn
                      text={"등록하기"}
                      onClick={() => {
                        if (!data.link?.trim()) {
                          return toast("연결링크를 입력해주세요.");
                        }
                        if (!data.file) {
                          return toast("PC 이미지를 등록해주세요");
                        }
                        if (!data.fileMo) {
                          return toast("모바일 이미지를 등록해주세요");
                        }
                        setSaveIndex(index);
                        setSaveModalOpen(true);
                      }}
                    />
                  </div>
                )}
              </DetailPage>
            ))}
          </div>
          <AddBtn
            style={{
              width: "100%",
              borderRadius: "3px",
              backgroundColor: "#636C73",
            }}
            onClick={() => {
              addBannerList();
            }}
          />
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}

      {delModalOpen ? (
        <Modal
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDelModalOpen}
          onClick={() => {
            delBanner();
          }}
        />
      ) : null}

      {editModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          btnTitle={"수정하기"}
          setModalOpen={setEditModalOpen}
          onClick={() => {
            editBanner();
          }}
        />
      ) : null}
    </>
  );
};

export default FinanceBanner;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
